// extracted by mini-css-extract-plugin
export default {"app":"Join_app__TgrxH","headerBar":"Join_headerBar__s081k","page2":"Join_page2__edw-G","pannel":"Join_pannel__BFLG6","btn":"Join_btn__IB5sM"};